import { memo } from 'react';
import { Box, SpaceBetween } from '@amzn/awsui-components-core';
import {
  DuplicateScanResultCardView,
  DuplicateScanResultItem,
} from './DuplicateScanResultCardView';

export type { DuplicateScanResultItem } from './DuplicateScanResultCardView';

interface DuplicateScanResultsViewProps {
  readonly results: readonly DuplicateScanResultItem[];
  readonly onRequestContributor?: (itemId: string) => void;
  /** Called when the user clicks through to a flagged duplicate article; consumers wire their own telemetry. */
  readonly onResultClick?: (articleId: string) => void;
}

/** Presentational list of duplicate-scan match cards, shared across the preauthor and publisher-review stages. */
export const DuplicateScanResultsView = memo(function DuplicateScanResultsView({
  results,
  onRequestContributor,
  onResultClick,
}: DuplicateScanResultsViewProps) {
  return (
    <SpaceBetween size="l">
      <Box>
        {results.map((item) => (
          <DuplicateScanResultCardView
            key={item.id}
            item={item}
            onRequestContributor={onRequestContributor}
            onArticleClick={onResultClick}
          />
        ))}
      </Box>
    </SpaceBetween>
  );
});
